<template>
	<div class="product-section py-3 px-0 bg-light rounded" style="width: 95%;" data-aos="fade-left" data-aos-duration="500" data-aos-easing="ease-in-sine">
		<div class="container">
			<div class="row">
				<div class="col-md-12 col-lg-3 mb-5 mb-lg-0 text-center">
					<h2 class="mb-4 section-title">{{ data['tittle'] }}</h2>
					<p class="mb-4" style="white-space: pre-line;">{{ data['content'] }}</p>
					<p><router-link to="services" class="btn rounded-pill">Xem thêm</router-link></p>
				</div> 

				<div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0" v-for="(value,key) in services">
					<router-link class="product-item" :to="'service/'+key" style="z-index: 0;">
						<img :src="value['url']" class="img-fluid product-thumbnail" style="z-index: 1;width: 70%;">
						<strong class="product-title" style="width: 100%;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;display: -webkit-box;-webkit-box-orient: vertical;">{{ value['name'] }}</strong>
						<h3 class="product-price">{{ value['price'] }}</h3>

						<span class="icon-cross">
							<img src="../../../public/images/r_arrow.svg" class="img-fluid">
						</span>
					</router-link>
				</div> 

			</div>
		</div>
	</div>
</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        data(){
            return{
                data:[],
				services:{}
            }
        },
        mounted(){
            const RecommentRef = ref(database, 'Recomment/');
            onValue(RecommentRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
				Object.keys(this.data['recomment']).forEach((e)=>{
					
					const serviceRef = ref(database, 'Services/'+e)
	
					onValue(serviceRef,(snapshot)=>{
						if (snapshot.val()) {
							this.services[e] = snapshot.val()
						}
					})
		
				})
            });
			
        }
    }
</script>